import UserUpdateForm from './UserUpdateForm';
export default UserUpdateForm;
